import colors from "./colors";
export default {
  button: {
    smallButton: {
      width: "5rem",
      height: "2.2rem",
      border: "none",
    },

    sampleButton: {
      width: "10rem",
      height: "3rem",
      color: colors.black,
      backgroundColor: colors.lightBlue,
      hoverBackgroundColor: colors.green1,
      border: "1px solid #BCBCCB",
    },
    sqaureButton: {
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "50%",
      border: "none",
      background: "#2A3DA3",
    },
  },
  textInput: {
    largeTextInput: {
      w_md: "35rem",
      h_md: "3rem",
      w_sm: "25rem",
      h_sm: "2.6rem",
    },
    largeTextIconInput: {
      w_md: "32.5rem",
      h_md: "3rem",
      w_sm: "25rem",
      h_sm: "2.6rem",
    },

    smallTextInput: {
      w_md: "16rem",
      h_md: "2.5rem",
    },
  },

  textArea: {
    largeTextArea: {
      w_md: "70rem",
      h_md: "5rem",
    },
    modalLargeTextArea: {
      w_md: "60rem",
      h_md: "4rem",
    },
  },

  radioButton: {
    smallRadioButton: {
      w_md: "1.1rem",
      h_md: "1.1rem",
      w_sm: "0rem",
      h_sm: "0rem",
    },
  },

  dropDown: {
    smallDropDown: {
      w_md: "18rem",
      h_md: "2.5rem",
      backgroundColor: colors.white,
    },
    smallDropDownNew: {
      w_md: "15rem",
      h_md: "2.5rem",
      backgroundColor: colors.white,
    },

    m_smallDropdown: {
      borderRadius: "0.5rem",
      w_md: "18rem",
      height: "3.5rem",
      WebkitBoxShadow: "0 0 7px #c1c1c1",
      boxShadow: "0 0 7px #c1c1c1",
    },
    m_smallDropdown1: {
      borderRadius: "0.5rem",
      w_md: "96%",
      height: "3.5rem",
      WebkitBoxShadow: "0 0 7px #c1c1c1",
      boxShadow: "0 0 7px #c1c1c1",
    },
    m_smallDropdown2: {
      borderRadius: "0.5rem",
      w_md: "32%",
      height: "3.5rem",
      WebkitBoxShadow: "0 0 7px #c1c1c1",
      boxShadow: "0 0 7px #c1c1c1",
    },
    mediumDropDown: {
      w_md: "27rem",
      h_md: "3.4rem",
      borderRadius: "0.5rem",
      WebkitBoxShadow: "0 0 7px #c1c1c1",
      boxShadow: "0 0 7px #c1c1c1",
    },

    mediumlargeDropDown: {
      w_md: "37rem",
      h_md: "3.4rem",
      borderRadius: "0.5rem",
      WebkitBoxShadow: "0 0 7px #c1c1c1",
      boxShadow: "0 0 7px #c1c1c1",
    },

    largeDropDown: {
      w_md: "35rem",
      h_md: "3rem",
    },
  },

  text: {
    formHeaderText: {
      fontSize: "1.8rem",
      fontWeight: "600",
      color: "#4d5e80",
      fontSize: "18px",
      fontFamily: "Poppins",
      lineHeight: "20px",
      fontWeight: "600",
    },
    labelText: {
      fontSize: "14px",
      fontFamily: "Poppins",
      fontWeight: "700",
      color: "#4d5e80",
      marginTop: "8px",
    },
    labelBoldText: {
      fontSize: "0.9rem",
      fontWeight: "600 !important",
    },
  },
};
